// Always-on banner shown while an org_admin is impersonating another
// user (item 210). Read-only badge + who's-really-in-control + an
// "End impersonation" action, mirroring MaintenanceBanner's shape.

import { useState } from 'react';
import { Eye, Lock } from 'lucide-react';
import { useWhoami, endImpersonation } from '../api/client';

export function ImpersonationBanner() {
  const { user } = useWhoami();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!user?.impersonatedBy) return null;

  const onEnd = async () => {
    setBusy(true);
    setErr(null);
    try {
      await endImpersonation();
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border-b border-nebula/30 bg-nebula/10">
      <div className="px-6 py-3 flex items-start gap-3 text-sm">
        <Eye className="h-4 w-4 mt-0.5 text-nebula shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-fg">
              Viewing as {user.email}
            </span>
            <span className="orb-badge bg-nebula/20 text-nebula border-nebula/40 inline-flex items-center gap-1">
              <Lock className="h-3 w-3" />
              read-only
            </span>
          </div>
          <p className="text-fg-muted mt-1">
            Impersonated by {user.impersonatedBy}. Writes are blocked for the
            duration of this session.
          </p>
          {err && <p className="text-danger mt-1">{err}</p>}
        </div>
        <button
          type="button"
          onClick={onEnd}
          disabled={busy}
          className="text-sm text-nebula hover:underline whitespace-nowrap disabled:opacity-50"
        >
          End impersonation
        </button>
      </div>
    </div>
  );
}
